import { render, staticRenderFns } from "./ModalConfirmSendToCommittee.vue?vue&type=template&id=c0f13770&scoped=true"
import script from "./ModalConfirmSendToCommittee.vue?vue&type=script&lang=js"
export * from "./ModalConfirmSendToCommittee.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmSendToCommittee.vue?vue&type=style&index=0&id=c0f13770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f13770",
  null
  
)

export default component.exports